<template>
  <div class="vehicle-summary">
    <div
      class="d-flex flex-wrap"
      style="gap: 4px 16px"
    >
      <span v-if="data.plate"><strong>Placa:</strong> {{ data.plate }}</span>
      <span v-if="vehicleTypeLabel"><strong>Tipo:</strong> {{ vehicleTypeLabel }}</span>
      <span v-if="brandModel"><strong>Veículo:</strong> {{ brandModel }}</span>
      <span v-if="data.color"><strong>Cor:</strong> {{ data.color }}</span>
      <span v-if="data.year"><strong>Ano:</strong> {{ data.year }}</span>
    </div>
    <div
      v-if="data.observation"
      class="text-muted small mt-1"
    >
      {{ data.observation }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'VehicleSummary',
  props: {
    data: { type: Object, default: () => ({}) },
  },
  computed: {
    brandModel() {
      return [this.data.brand, this.data.model].filter(Boolean).join(' ')
    },
    vehicleTypeLabel() {
      const map = {
        carro: 'Carro',
        moto: 'Moto',
        caminhao: 'Caminhão',
        onibus: 'Ônibus',
        outro: 'Outro',
      }
      return map[this.data.vehicle_type] || this.data.vehicle_type || ''
    },
  },
}
</script>
